import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

import { t } from '@vk-hr-tek/core/translations';

export class Employee {
  @IsUUID(undefined, {
    message: () => t('settings.dto.saveCompanyUnep.wrongEmployeeText'),
  })
  @IsNotEmpty({
    message: () => t('settings.dto.saveCompanyUnep.wrongEmployeeText'),
  })
  id: string;

  @IsString()
  @IsNotEmpty()
  signType: string;
}
